export const onFinanceData = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  title: 'Did you buy it on finance?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/933cb6b1a040-tooliconpaycard.jpg',
  },
  standFirst:
    'This includes buying with a credit card, personal loan, hire   purchase or personal contract purchase (PCP).',
}
